import { Map, List } from 'immutable';

import { ApiResponseHelper } from 'omni-common-ui';

import {
  FETCH_ONLINE_HOMEWORK_REQUEST,
  FETCH_ONLINE_HOMEWORK_SUCCESS,
  FETCH_ONLINE_HOMEWORK_FAILURE,
} from './actions';
import OnlineHomework from './model';
import StudentOnlineHomework from './StudentOnlineHomework';

export default function onlineHomeworkReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_ONLINE_HOMEWORK_REQUEST:
      return state.set(action.groupId, ApiResponseHelper.create({ loading: true }));
    case FETCH_ONLINE_HOMEWORK_SUCCESS:
      return state.set(
        action.groupId,
        ApiResponseHelper.create(setOnlineHomework(state, action.payload))
      );
    case FETCH_ONLINE_HOMEWORK_FAILURE:
      return state.set(action.groupId, ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function setOnlineHomework(state, payload) {
  return new List(payload.map((homeworkBySession) => {
    const studentOnlineHomeworkResults = new List(
      homeworkBySession.studentOnlineHomeworkResults.map((homeworkByStudent) =>
        StudentOnlineHomework
          .create(homeworkByStudent)
          .set('sessionId', `${homeworkBySession.sessionId}`)
      ));
    return OnlineHomework
      .create(homeworkBySession)
      .set('studentOnlineHomeworkResults', studentOnlineHomeworkResults);
  }));
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/reducer.js